<template>
  <div>
    <el-dialog
        width="800px"
        title="Tạo đợt thu"
        :visible.sync="isOpenImportData"
        :before-close="handleClose"
        :close-on-click-modal="false"
        @open="handleOpen"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="Chọn tháng/đợt thu" label-width="150px" prop="monthAndYearUpload">
          <el-row>
            <el-col :span="21">
              <el-date-picker
                  style="width: 135px"
                  class="custom-date-picker"
                  :clearable="false"
                  v-model="form.monthAndYearUpload"
                  type="month"
                  @change="handelChangeDate"
                  placeholder="Chọn tháng"
                  value-format="M-yyyy"
                  format="MM-yyyy"
                  :time-arrow-control="false"
              >
              </el-date-picker>
              <el-select
                  style="width: 130px; margin-left: 10px"
                  class="input-common"
                  v-model="form.turn"
                  placeholder="Chọn đợt thu"
                  @change="changeTurn"
              >
                <el-option
                    v-for="item in collectionTurn"
                    :key="item"
                    :value="item"
                    :label="`Đợt ${item}`"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="4">
              <span>Mô tả đợt thu</span>
            </el-col>
            <el-col :span="14" style="margin-left: 20px">
              <el-input v-model="form.descriptionTurn" autocomplete="off" placeholder="Mời nhập mô tả đợt thu"
                        type="textarea"
                        style="width: 335px; font-family: Roboto,serif"
              ></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="Khoảng thời gian" label-width="140px" prop="listDay">
          <el-date-picker
              style="width:335px; margin-left: 5px"
              format="dd-MM-yyyy"
              v-model="form.listDay"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="-"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Chọn khoản" label-width="140px" prop="selectedFees">
          <el-row>
            <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
            >
              Chọn tất cả
            </el-checkbox>
            <span
                style="color: blue; text-decoration: underline; margin-left: 20px; cursor: pointer;"
                @click="dialogSelectRevenueVisible = true"
            >
              Chi tiết
            </span>
          </el-row>
          <el-row>
            <span>Tổng số khoản được chọn: {{ this.form.selectedFees.length }}</span>
          </el-row>
        </el-form-item>
        <el-form-item label="Dữ liệu điểm danh" label-width="130px" v-if="this.$props.type ==='CLASS'">
          <el-row>
            <el-col :span="4">
              <el-radio v-model="form.monthBeforeOrAfter" :label="false">Tháng được chọn</el-radio>
            </el-col>
            <el-col :offset="2" :span="4">
              <el-radio v-model="form.monthBeforeOrAfter" :label="true">Trước 1 tháng</el-radio>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="Thiếu thừa" label-width="130px" v-if="this.$props.type ==='GROUP'">
          <el-row>
            <el-col :span="4">
              <el-radio v-model="form.monthBeforeOrAfter" :label="false">Tháng được chọn</el-radio>
            </el-col>
            <el-col :offset="2" :span="4">
              <el-radio v-model="form.monthBeforeOrAfter" :label="true">Trước 1 tháng</el-radio>
            </el-col>
          </el-row>
          <el-row>
            <div class="title-select">
            <span v-if="form.monthBeforeOrAfter === true && parseInt(form.monthAndYearUpload.split('-')[0]) !== 1">Tháng {{
                parseInt(form.monthAndYearUpload.split('-')[0]) - 1
              }}-{{ form.monthAndYearUpload.split('-')[1] }}</span>
              <span v-if="form.monthBeforeOrAfter === false">Tháng {{ form.monthAndYearUpload }}</span>
              <span v-if="form.monthBeforeOrAfter === true && parseInt(form.monthAndYearUpload.split('-')[0]) === 1">Tháng 12-{{
                  parseInt(form.monthAndYearUpload.split('-')[1]) - 1
                }}</span>
            </div>
          </el-row>
        </el-form-item>

        <el-form-item label="Thiếu thừa" label-width="130px" v-if="this.$props.type ==='CLASS'">
          <el-row>
            <el-col>
              <el-radio v-model="form.allTransaction" :label="true"
                        @change="handleRadioChange('allTransaction')">Tất cả
              </el-radio>
              <el-radio v-model="form.forwardTransaction" :label="true"
                        @change="handleRadioChange('forwardTransaction')">Kết chuyển
              </el-radio>
              <el-radio v-model="form.noForwardTransaction" :label="true"
                        @change="handleRadioChange('noForwardTransaction')">Không chuyển
              </el-radio>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="" label-width="130px" v-if="this.$props.type ==='GROUP'">
          <el-row>
            <el-col>
              <el-radio v-model="form.allTransaction" :label="true"
                        @change="handleRadioChange('allTransaction')">Tất cả
              </el-radio>
              <el-radio v-model="form.forwardTransaction" :label="true"
                        @change="handleRadioChange('forwardTransaction')">Kết chuyển
              </el-radio>
              <el-radio v-model="form.noForwardTransaction" :label="true"
                        @change="handleRadioChange('noForwardTransaction')">Không chuyển
              </el-radio>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="Điểm danh, thiếu thừa" v-if="this.$props.type ==='CLASS'">
          <div class="title-select">
            <span v-if="form.monthBeforeOrAfter === true && parseInt(form.monthAndYearUpload.split('-')[0]) !== 1">Tháng {{
                parseInt(form.monthAndYearUpload.split('-')[0]) - 1
              }}-{{ form.monthAndYearUpload.split('-')[1] }}</span>
            <span v-if="form.monthBeforeOrAfter === false">Tháng {{ form.monthAndYearUpload }}</span>
            <span v-if="form.monthBeforeOrAfter === true && parseInt(form.monthAndYearUpload.split('-')[0]) === 1">Tháng 12-{{
                parseInt(form.monthAndYearUpload.split('-')[1]) - 1
              }}</span>
          </div>
        </el-form-item>
      </el-form>
      <div class="custom_button">
        <el-button type="primary" @click="handleExcelImport" :loading="loadingImport">Khởi tạo<i
            class="el-icon-upload el-icon-right"></i></el-button>
        <el-button @click="handleClose" type="danger"><i class="el-icon-circle-close"/> Đóng
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="Danh sách khoản được chọn"
        :visible.sync="dialogSelectRevenueVisible"
        width="600px"
        :before-close="handleCloseDialogSelectRevenueVisible"
    >
      <el-checkbox-group
          v-model="form.selectedFees"
          @change="handleSelectedFeesChange"
      >
        <el-checkbox
            v-for="item in feeOptions"
            :key="item.id"
            :label="item.id"
            style="display: block; margin-top: 5px"
        >
          {{ item.name }}
        </el-checkbox>
      </el-checkbox-group>

      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogSelectRevenueVisible = false" type="danger">Đóng</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>

import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import moment from "moment/moment";

export default {
  name: "ImportDataRevenueDialog",
  data() {
    return {
      pickerStartDateOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        },
      },

      pickerEndDateOptions: {
        disabledDate: (time) => {
          const startDate = new Date(this.startDate);
          return time.getTime() <= startDate.getTime();
        },
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Tuần trước',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Tháng trước',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '3 Tháng trước',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        },
          {
            text: '6 Tháng trước',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          },]
      },
      loadingButton: false,
      collectionTurn: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
      isInputDescriptionTurn: false,
      feeOptions: [],
      form: {
        descriptionTurn: "",
        monthAndYearUpload: moment().format('MM-yyyy'),
        turn: 1,
        startDate: "",
        endDate: "",
        listDay: [],
        selectedFees: [],
        month: 0,
        year: 0,
        monthBeforeOrAfter: true,
        allTransaction: true,
        forwardTransaction: false,
        noForwardTransaction: false,
      },
      rules: {
        turn: [{
          required: true,
          message: "Đợt không được để trống!",
          trigger: "change",
        }],
        monthAndYearUpload: [{
          required: true,
          message: "Tháng không được để trống!",
          trigger: "change",
        }],
        startDate: [{
          required: true,
          message: "Ngày bắt đầu không được để trống!",
          trigger: "change",
        }],
        endDate: [{
          required: true,
          message: "Ngày kết thúc không được để trống!",
          trigger: "change",
        }],
        listDay: [{
          required: true,
          message: "Khoảng thời gian không được để trống!",
          trigger: "change",
        }],
      },
      loadingImport: false,
      checkAll: false,
      isIndeterminate: false,
      dialogSelectRevenueVisible: false,
    }
  },
  props: {
    isOpenImportData: {
      type: Boolean,
      default: false
    },
    listIdRevenueManagement: {
      type: Array,
      default: () => [],
    },
    listIdKids: {
      type: Array,
      default: () => [],
    },
    dataSearch: {
      type: Object,
      default: () => null
    },
    type: {
      type: String,
      default: () => "",
    },
  },
  methods: {
    handleRadioChange(selectedRadio) {
      if (selectedRadio === 'allTransaction') {
        this.form.forwardTransaction = false;
        this.form.noForwardTransaction = false;
      } else if (selectedRadio === 'forwardTransaction') {
        this.form.allTransaction = false;
        this.form.noForwardTransaction = false;
      } else if (selectedRadio === 'noForwardTransaction') {
        this.form.allTransaction = false;
        this.form.forwardTransaction = false;
      }
    },
    handleCheckAllChange(val) {
      if (val) {
        // Chọn tất cả nhưng không vượt quá 20
        const allIds = this.feeOptions.map(item => item.id);
        if (allIds.length > 20) {
          NotifyMessage.leftCornerNotificationWarning("Bạn chỉ được chọn tối đa 20 khoản.")
          this.checkAll = false;
          return;
        }
        this.form.selectedFees = allIds;
      } else {
        this.form.selectedFees = [];
      }
      this.isIndeterminate = false;
    },
    handleSelectedFeesChange(val) {
      const optionCount = this.feeOptions.length;

      if (val.length > 20) {
        NotifyMessage.leftCornerNotificationWarning("Bạn chỉ được chọn tối đa 20 khoản.")
        const lastSelected = val[val.length - 1];
        this.form.selectedFees = val.filter(id => id !== lastSelected);
        return;
      }

      this.checkAll = val.length === optionCount;
      this.isIndeterminate = val.length > 0 && val.length < optionCount;
    },
    handleOpen() {
      this.form.month = Number(this.form.monthAndYearUpload.split('-')[0])
      this.form.year = Number(this.form.monthAndYearUpload.split('-')[1])
      this.changeTurn()
    },
    async changeTurn() {
      let data = {
        listIdRevenueManagement: this.$props.listIdRevenueManagement,
        month: this.form.month,
        createdYear: this.form.year,
        kidStatus: this.dataSearch.kidStatus,
        idSchool: 0,
        idGrade: this.dataSearch.idGrade,
        idClass: this.dataSearch.idClass,
        idGroup: this.dataSearch.idGroup,
        collectionTurn: this.form.turn,
        name: "",
        page: 1,
        limit: 10,
        statusList: [],
      }
      if (this.$props.type === "CLASS") {
        await revenueManagementService.findAllRevenueManagementStudent(data).then(res => {
          this.form.selectedFees = [];
          this.feeOptions = res.data.data;
          this.form.selectedFees = this.feeOptions.filter(item => item.active).map(item => item.id);
          this.checkAll = this.feeOptions.length === this.form.selectedFees.length;
        }).catch(err => {
          console.log(err);
          NotifyMessage.leftCornerNotificationError("Lỗi truyền tải dữ liệu!");
        });
      } else {
        await revenueManagementService.findAllRevenueManagementStudentForGroup(data).then(res => {
          this.form.selectedFees = [];
          this.feeOptions = res.data.data;
          this.form.selectedFees = this.feeOptions.filter(item => item.active).map(item => item.id);
          this.checkAll = this.feeOptions.length === this.form.selectedFees.length;
        }).catch(err => {
          console.log(err);
          NotifyMessage.leftCornerNotificationError("Lỗi truyền tải dữ liệu!");
        });
      }

    },
    handleClose() {
      this.$refs['form'].resetFields();
      this.handleClear()
      this.$emit("close");
    },
    handleClear() {
      this.form.descriptionTurn = ""
      this.form.monthAndYearUpload = moment().format('MM-yyyy')
      this.form.turn = 1
      this.form.startDate = ""
      this.form.endDate = ""
      this.form.listDay = []
      this.form.selectedFees = []
      this.form.month = 0
      this.form.year = 0
      this.form.monthBeforeOrAfter = true
      this.form.allTransaction = true
      this.form.forwardTransaction = false
      this.form.noForwardTransaction = false
      this.checkAll = false
    },
    handelChangeDate(val) {
      this.form.month = Number(val.split('-')[0])
      this.form.year = Number(val.split('-')[1])
      this.changeTurn()
    },
    handleExcelImport() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.startDate = moment(this.form.listDay[0]).format('YYYY-MM-DD')
          this.form.endDate = moment(this.form.listDay[1]).format('YYYY-MM-DD')
          let data = {
            month: this.form.month,
            year: this.form.year,
            collectionTurn: this.form.turn,
            descriptionTurn: this.form.descriptionTurn,
            startDate: this.form.startDate,
            endDate: this.form.endDate,
            listIdRevenueManagement: this.form.selectedFees,
            listIdKids: this.$props.listIdKids,
            monthBeforeOrAfter: this.form.monthBeforeOrAfter,
            allTransaction: this.form.allTransaction,
            forwardTransaction: this.form.forwardTransaction,
            noForwardTransaction: this.form.noForwardTransaction,
            idGroup: this.$props.dataSearch.idGroup,
            idClass: this.$props.dataSearch.idClass,
          }
          if (this.$props.type === "CLASS") {
            data.idGroup = "0"
            revenueManagementService.initializeDataRevenueManagement(data).then(() => {
              NotifyMessage.leftCornerNotificationSuccess("Khởi tạo dữ liệu thành công!")
              this.handleClose()
            }).catch((err) => {
              console.log(err)
              NotifyMessage.leftCornerNotificationError("Khởi tạo dữ liệu thất bại!")
            })
          } else {
            data.idClass = "0"
            revenueManagementService.initializeDataRevenueManagementForGroup(data).then(() => {
              NotifyMessage.leftCornerNotificationSuccess("Khởi tạo dữ liệu thành công!")
              this.handleClose()
            }).catch((err) => {
              console.log(err)
              NotifyMessage.leftCornerNotificationError("Khởi tạo dữ liệu thất bại!")
            })
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },

    handleCloseDialogSelectRevenueVisible() {
      this.dialogSelectRevenueVisible = false
    },

  },


}
</script>

<style lang="scss" scoped>

.button_method {
  text-align: left;
}

.input-common {
  margin-right: 5px;
}

.excel-upload-input {
  display: none;
}

.overwrite {
  margin-top: 5px;
}

.excel_upload {
  float: left;
  margin-right: 10px;
}

/deep/ .el-form-item__label {
  text-align: left;
}

.custom_button {
  display: flex;
  justify-content: right;
  margin-top: 20px;
}

.custom_button_error {
  display: flex;
  justify-content: right;
  margin-top: 20px;
}

.block {
  /deep/ .el-input__inner {
    border: 1px solid #F56C6C;
    border-radius: 4px;
  }
}

.title-select {
  color: #00a1ff;
}

.message-err {
  color: #F56C6C;
  margin-top: 6px;
  font-size: 11px;
}
</style>